import { cipo } from 'cipo';
    
cipo.controller('smartmapController', 
function ($scope, $state, userService) {
  $scope.moduleName = userService.system.mNames[$state.current.code];
});